<template>
	<BaseCenteredMessage hideLogoutButton hideActions>
		<template v-if="isLoggingOut" #title>
			<BaseIcon name="mono/load" class="mr-8 h-16 w-16" />
			Logging out
		</template>
		<template v-else #title>Successfully logged out</template>
		<template #details>
			<p class="mt-32">
				This page will close automatically,
				<br />
				if not, please close this tab.
			</p>
		</template>
	</BaseCenteredMessage>
</template>

<script>
import analytics from 'shared/utils/analytics'

export default {
	data() {
		return {
			isLoggingOut: true,
		}
	},
	computed: {
		isAuthenticationLoading() {
			return this.$auth.loading.value
		},
	},
	watch: {
		isAuthenticationLoading: {
			immediate: true,
			async handler(loading) {
				if (loading) return
				if (this.$auth.isAuthenticated.value) await this.$auth.logout()
				if (this.$route.query.close) setTimeout(window.close, 500)
				if (!this.$route.query.close && this.$route.query.post_logout_redirect_uri) {
					window.location.href = this.$route.query.post_logout_redirect_uri
				}
				setTimeout(() => (this.isLoggingOut = false), 1500)
			},
		},
	},
	mounted() {
		analytics.page('Logout')
	},
}
</script>
